import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=3c442603&scoped=true&"
import script from "./Filters.vue?vue&type=script&setup=true&lang=js&"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c442603",
  null
  
)

export default component.exports